export const exportJSON = (diagramData) => {
  return new Blob([JSON.stringify(diagramData)], {
    type: "application/json;charset=utf-8"
  });
};
